export default __webpack_public_path__ + "static/media/product-design.66a5e0b3.jpeg";